import React from 'react'

import NewService from './NewService'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewServicePage = () => (
  <section>
    <header>
      <PageTitle>New service</PageTitle>
    </header>
    <NewService showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewServicePage



// WEBPACK FOOTER //
// ./src/components/Services/NewServicePage.jsx